<style lang="scss" scoped>
  @import '../../../sass/variables';

  p .fa {
    font-size: 16px;
  }

  .rounded-20 {
    border-radius: 20px;
  }

  .rounded-15 {
    border-radius: 15px;
  }

  .bg-light-gray {
    background-color: $white-gray;
  }

  .stats-content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 0;

    .icon-size {
      height: 50px;
    }
  }

  .stats-icon {
    line-height: 10rem;
  }

  .stats-info {
    padding-top: 0.5rem;
    padding-left: 0;

    .info-status {
      color: $gray-light;
      font-weight: 400;
      text-transform: uppercase;
      font-size: 11px;
    }

    .info-count {
      color: $gray-dark;
      font-size: 50px;
      font-weight: 400;
      letter-spacing: -0.75px;
    }

    .info-percent {
      font-weight: 700;
      color: $gray-dark;
      font-size: 11px;
    }

    .font-red {
      color: $pink;
    }

    .font-green {
      color: $green;
    }
  }

  .subtitle-stats h4 {
    font-weight: 400;
    color: $gray-dark;
    letter-spacing: -0.27px;
  }
</style>

<template>
  <section class="mail-stats">
    <div class="row">
      <div class="col-12 pl-30px d-flex align-items-center">
        <h2 class="page-subtitle">
          {{ mail.title || 'Modelo sem título' }}
        </h2>
        <div class="d-flex align-items-baseline ml-auto">
          <div class="btn-group ml-4">
            <button
              type="button"
              class="salesflow-btn salesflow-btn-small salesflow-btn-transparent"
              @click="createCampaign()"
            >
              <IconPlus :color="'#71767D'" />
              <span class="ml-2">{{ __('Criar campanha') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-5">
        <div class="bg-white mt-4 with-shadow rounded-20 p-4">
          <div class="subtitle-stats">
            <h4>{{ __('Entrega de e-mails') }}</h4>
          </div>
          <div class="col-12 p-0 mt-4">
            <div class="row">
              <div class="col-4">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/sent.svg"
                        class="icon-size"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('total')"
                        />
                        <span v-else>{{ getStatValue('total') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('total') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="! isStatLoading('total')">100%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/rejected.svg"
                        class="icon-size"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count font-red">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('dropped')"
                        />
                        <span v-else>{{ getStatValue('dropped') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('dropped') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="isStatPercentageReady('dropped')">{{ getStatPercentage('dropped') | percent }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/delivered.svg"
                        class="icon-size"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count font-green">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('delivered')"
                        />
                        <span v-else>{{ getStatValue('delivered') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('delivered') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="isStatPercentageReady('delivered')">{{ getStatPercentage('delivered') | percent }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="subtitle-stats mt-5">
            <h4>{{ __('Engajamento') }}</h4>
          </div>
          <div class="col-12 p-0 mt-4">
            <div class="row">
              <div class="col-3">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/open.svg"
                        height="35px"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('opened')"
                        />
                        <span v-else>{{ getStatValue('opened') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('opened') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="isStatPercentageReady('opened')">{{ getStatPercentage('opened') | percent }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/clicked.svg"
                        height="50px"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count font-green">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('clicked')"
                        />
                        <span v-else>{{ getStatValue('clicked') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('clicked') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="isStatPercentageReady('dropped')">{{ getStatPercentage('clicked') | percent }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/unsub.svg"
                        height="35px"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count font-red">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('unsubscribed')"
                        />
                        <span v-else>{{ getStatValue('unsubscribed') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('unsubscribed') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="isStatPercentageReady('unsubscribed')">{{ getStatPercentage('unsubscribed') | percent }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div
                  class="bg-light-gray rounded-15"
                  style="height: 146px"
                >
                  <div class="row h-100">
                    <div class="col-6 stats-icon stats-content">
                      <img
                        src="/build/icons/automation/spam.svg"
                        class="icon-size"
                      >
                    </div>
                    <div class="col-6 stats-info">
                      <div class="info-count">
                        <span
                          class="fa fa-circle-o-notch fa-spin"
                          v-if="isStatLoading('complained')"
                        />
                        <span v-else>{{ getStatValue('complained') | number(0) }}</span>
                      </div>
                      <div class="info-status">
                        {{ getStatLabel('complained') }}
                      </div>
                      <div class="info-percent">
                        <span v-if="isStatPercentageReady('complained')">{{ getStatPercentage('complained') | percent }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MailSend
      :user="user"
      :id="mail.id"
    />
  </section>
</template>

<script>
import { BButtonGroup } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BButtonGroup,
  },

  props: ['user', 'mail'],

  created () {
    for (const stat of Object.keys(this.stats)) {
      this.getStat(stat);
    }
  },

  data () {
    return {
      stats: {
        total: {
          value: 0,
          loading: true,
          label: this.__('ENVIADOS'),
        },
        dropped: {
          value: 0,
          tries: 1,
          loading: true,
          engagement: false,
          label: this.__('REJEITADOS'),
        },
        delivered: {
          value: 0,
          tries: 1,
          loading: true,
          engagement: false,
          label: this.__('ENTREGUES'),
        },
        opened: {
          value: 0,
          tries: 1,
          loading: true,
          engagement: true,
          label: this.__('ABERTOS'),
        },
        clicked: {
          value: 0,
          tries: 1,
          loading: true,
          engagement: true,
          label: this.__('CLICADOS'),
        },
        unsubscribed: {
          value: 0,
          tries: 1,
          loading: true,
          engagement: true,
          label: this.__('DESINSCRITOS'),
        },
        complained: {
          value: 0,
          tries: 1,
          loading: true,
          engagement: true,
          label: this.__('MARCOU COMO SPAM'),
        },
      },
    };
  },

  methods: {
    getStat (stat) {
      this.$http.get(`/mail/${this.mail.id}/mailstat/${stat}`)
        .then(({ data: value }) => {
          this.setStatValue(stat, value);
          this.setStatLoadingState(stat, false);
        })
        .catch((error) => {
          if (this.getStatTries(stat) <= 3) {
            this.addStatTry(stat);
            this.getStat(stat);

            return;
          }

          this.setStatLoadingState(stat, false);

          Alert.error(this.__('Erro ao carregar: ') + this.getStatLabel(stat) + this.__('. Tente novamente.'));
        });
    },

    async createCampaign () {
      if (! await Confirm(this.__('Criar campanha com este e-mail?'))) {
        return;
      }

      this.$http.post(`/automation/mail/${this.mail.id}`, this.mail)
        .then((response) => {
          window.location = `/automation/${response.data.id}`;
        });
    },

    isStatLoading (stat) {
      return this.stats[stat].loading;
    },

    setStatLoadingState (stat, value) {
      this.stats[stat].loading = value;
    },

    getStatValue (stat) {
      return this.stats[stat].value;
    },

    setStatValue (stat, value) {
      this.stats[stat].value = value;
    },

    getStatTries (stat) {
      return this.stats[stat].tries;
    },

    addStatTry (stat) {
      this.stats[stat].tries += 1;
    },

    getStatLabel (stat) {
      return this.__(this.stats[stat].label);
    },

    isStatPercentageReady (stat) {
      return ! this.isStatLoading(stat) && ! this.isStatLoading(this.stats[stat].engagement ? 'delivered' : 'total');
    },

    getStatPercentage (stat) {
      return this.getStatValue(stat) / this.getStatValue(this.stats[stat].engagement ? 'delivered' : 'total');
    },
  },
};
</script>
